import { useEffect, useState } from "react";
import api, { inr } from "../../lib/api";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { IndianRupee, ShoppingBag, Package, Users } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
  if (!stats) return <p className="text-ink-soft">Loading…</p>;

  const cards = [
    { label: "Revenue", value: inr(stats.revenue), icon: IndianRupee },
    { label: "Orders", value: stats.total_orders, icon: ShoppingBag },
    { label: "Products", value: stats.total_products, icon: Package },
    { label: "Customers", value: stats.total_customers, icon: Users },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-serif text-4xl tracking-tight mb-1">Dashboard</h1>
      <p className="text-ink-soft text-sm mb-8">An overview of your atelier.</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
        {cards.map((c) => (
          <div key={c.label} className="border border-line rounded-md p-5" data-testid={`stat-${c.label.toLowerCase()}`}>
            <div className="flex items-center justify-between mb-4">
              <span className="overline text-ink-soft">{c.label}</span>
              <c.icon size={16} className="text-gold-deep" />
            </div>
            <p className="font-serif text-3xl tracking-tight">{c.value}</p>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="border border-line rounded-md p-6">
          <h3 className="font-serif text-2xl mb-6">Top pieces by revenue</h3>
          {stats.top_products.length === 0 ? (
            <p className="text-sm text-ink-soft">No sales yet.</p>
          ) : (
            <ResponsiveContainer width="100%" height={260}>
              <BarChart data={stats.top_products} margin={{ left: -10 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#eee" vertical={false} />
                <XAxis dataKey="name" tick={{ fontSize: 10 }} stroke="#999" />
                <YAxis tick={{ fontSize: 10 }} stroke="#999" />
                <Tooltip formatter={(v) => inr(v)} />
                <Bar dataKey="revenue" fill="#c5a880" radius={[3, 3, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          )}
        </div>

        <div className="border border-line rounded-md p-6">
          <h3 className="font-serif text-2xl mb-6">Recent orders</h3>
          <div className="space-y-3">
            {stats.recent_orders.length === 0 && <p className="text-sm text-ink-soft">No orders yet.</p>}
            {stats.recent_orders.map((o) => (
              <div key={o.order_id} className="flex items-center justify-between text-sm border-b border-line pb-3">
                <div>
                  <p className="mono text-xs">#{o.order_id.slice(0, 8).toUpperCase()}</p>
                  <p className="text-ink-soft text-xs mt-0.5">{o.user_name}</p>
                </div>
                <div className="text-right">
                  <p>{inr(o.total)}</p>
                  <span className="overline text-gold-deep capitalize">{o.status}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
